import { ViewerModule } from '@g.frame/core';
import { BoxBufferGeometry, Material, Mesh, MeshBasicMaterial, MeshStandardMaterial, Quaternion } from 'three';
import { FBX_MODEL, TEXTURE } from '@g.frame/common.loaders';
export class Instrument extends ViewerModule {
    constructor(cameraParent) {
        super();
        this.cameraParent = cameraParent;
        this.hand = 'right';
        this.mousePickingOrientation = new Quaternion();
        this.stickToHand = false;
        const testBox = new Mesh(new BoxBufferGeometry(0.01, 0.01, 0.01), new MeshBasicMaterial({ color: '#22ee22' }));
        // this.addObject(testBox);
        this.enable(false);
    }
    loadResources(loader) {
        if (!this.modelConfig)
            return;
        if (this.modelConfig.modelPath) {
            loader.addResources([{
                    name: `${this.constructor.name}_model`,
                    type: FBX_MODEL,
                    url: this.modelConfig.modelPath
                }]);
        }
        this.modelConfig.material.forEach(material => {
            for (let textureType in material.texturePaths) {
                const path = material.texturePaths[textureType];
                if (path) {
                    loader.addResources([{
                            name: `${this.constructor.name}_${material.materialName}_${textureType}`,
                            type: TEXTURE,
                            url: path
                        }]);
                }
            }
        });
    }
    prepareResources(loader) {
        if (!this.modelConfig)
            return;
        const model = this.model = loader.getResource(`${this.constructor.name}_model`);
        this.modelConfig.material.forEach(materialConfig => {
            let material;
            if (materialConfig.type === 'base') {
                material = new MeshBasicMaterial();
                if (materialConfig.texturePaths.baseColor)
                    material.map = loader.getResource(`${this.constructor.name}_${materialConfig.materialName}_baseColor`);
            }
            else {
                material = new MeshStandardMaterial();
                if (materialConfig.texturePaths.baseColor)
                    material.map = loader.getResource(`${this.constructor.name}_${materialConfig.materialName}_baseColor`);
                if (materialConfig.texturePaths.normal)
                    material.normalMap = loader.getResource(`${this.constructor.name}_${materialConfig.materialName}_normal`);
                if (materialConfig.texturePaths.orm) {
                    material.aoMap = loader.getResource(`${this.constructor.name}_${materialConfig.materialName}_orm`);
                    material.roughnessMap = loader.getResource(`${this.constructor.name}_${materialConfig.materialName}_orm`);
                    material.metalnessMap = loader.getResource(`${this.constructor.name}_${materialConfig.materialName}_orm`);
                }
            }
            material.name = materialConfig.materialName;
            material.needsUpdate = true;
            model.traverse(object => {
                if (object instanceof Mesh) {
                    if (object.material instanceof Material && object.material.name === materialConfig.materialName) {
                        object.material.dispose();
                        object.material = material;
                    }
                    else if (object.material instanceof Array) {
                        object.material.forEach((oldMaterial, index, arr) => {
                            if (oldMaterial.name === materialConfig.materialName) {
                                oldMaterial.dispose();
                                arr[index] = material;
                            }
                        });
                    }
                }
                this.modelConfig.processingFunction && this.modelConfig.processingFunction(object);
            });
        });
        this.addObject(model);
    }
    setOculusModel(model) {
        this.questModel = model;
    }
    action(triggerValue) {
        this.fire('action');
    }
    enable(b) {
        this.uiObject.visible = b;
        this.enabled = b;
    }
}
